/**
 * The portal title alternates between "Battle Chess" and "Batalla Chess"
 * every few minutes, wiped in by a sweeping bar of sparks (see the
 * .title-wrap rules in styles.css for the clip-path/animation mechanics —
 * this module only ever flips one class and refills two text layers).
 */

const NAMES = [
  { main: 'Battle', rest: 'Chess' },
  { main: 'Batalla', rest: 'Chess' },
];

const SWEEP_MS = 1800;
const CYCLE_MS = 5 * 60 * 1000;
const SPARK_COUNT = 18;

function fillLayer(layer, name) {
  layer.textContent = '';
  layer.append(name.main);
  const rest = document.createElement('span');
  rest.textContent = name.rest;
  layer.append(rest);
}

function spawnSparks(sweep) {
  for (let i = 0; i < SPARK_COUNT; i++) {
    const spark = document.createElement('i');
    spark.className = 'title-spark';
    const t = i / (SPARK_COUNT - 1);
    spark.style.left = `${t * 100}%`;
    spark.style.animationDelay = `${t * SWEEP_MS * 0.85}ms`;
    spark.style.setProperty('--dx', `${(Math.random() - 0.5) * 30}px`);
    spark.style.setProperty('--dy', `${-Math.random() * 24 - 6}px`);
    spark.addEventListener('animationend', () => spark.remove());
    sweep.appendChild(spark);
  }
}

export function initPortalTitleSweep() {
  const wrap = document.getElementById('portal-title');
  if (!wrap) return;
  const oldLayer = wrap.querySelector('.title-old');
  const newLayer = wrap.querySelector('.title-new');
  const sweep = wrap.querySelector('.title-sweep');
  let index = 0;

  fillLayer(oldLayer, NAMES[index]);

  function runSweep() {
    const nextIndex = (index + 1) % NAMES.length;
    fillLayer(newLayer, NAMES[nextIndex]);

    wrap.classList.remove('is-sweeping');
    void wrap.offsetWidth; // restart CSS animations from the top
    wrap.classList.add('is-sweeping');
    spawnSparks(sweep);

    setTimeout(() => {
      index = nextIndex;
      fillLayer(oldLayer, NAMES[index]);
      wrap.classList.remove('is-sweeping');
    }, SWEEP_MS);
  }

  setInterval(runSweep, CYCLE_MS);
}
